/* Keep inserted guidance cards from leaving a partial product row. Product
 * order, page boundaries and the number of products remain unchanged. */
(function () {
  function spansFor(items, columns) {
    const spans = items.map(() => 1);
    let remaining = (columns - items.length % columns) % columns;
    let position = 0;
    items.forEach((isCard, index) => {
      const extra = isCard ? Math.min(remaining, columns - position % columns - 1) : 0;
      spans[index] += extra;
      remaining -= extra;
      position += spans[index];
    });
    return spans;
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { spansFor };
  if (typeof document === 'undefined') return;

  const grids = new Map();
  const selector = '.swap-collection-grid';
  const cardSelector = '.build-grid-feature-card, .swap-promo-card, .acquisition-card-container';
  function connect(grid) {
    let frame;
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(balance);
    };
    const mutations = new MutationObserver(schedule);
    const resize = new ResizeObserver(schedule);
    function balance() {
      frame = null;
      mutations.disconnect();
      const children = [...grid.children];
      const visible = children.filter(child => getComputedStyle(child).display !== 'none');
      const columns = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length;
      const spans = spansFor(visible.map(child => child.matches(cardSelector)), columns || 1);
      children.filter(child => child.matches(cardSelector)).forEach(child => child.style.removeProperty('grid-column'));
      visible.forEach((child, index) => {
        if (child.matches(cardSelector) && spans[index] > 1) child.style.gridColumn = `span ${spans[index]}`;
      });
      mutations.observe(grid, { childList: true });
      children.forEach(child => mutations.observe(child, { attributes: true, attributeFilter: ['style', 'class'] }));
    }
    resize.observe(grid);
    schedule();
    grids.set(grid, () => { mutations.disconnect(); resize.disconnect(); cancelAnimationFrame(frame); });
  }
  function discover() {
    for (const [grid, disconnect] of grids) {
      if (!grid.isConnected) { disconnect(); grids.delete(grid); }
    }
    document.querySelectorAll(selector).forEach(grid => { if (!grids.has(grid)) connect(grid); });
  }
  let discoveryFrame;
  new MutationObserver(records => {
    if (!records.some(record => [...record.addedNodes, ...record.removedNodes].some(node =>
      node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))))) return;
    if (!discoveryFrame) discoveryFrame = requestAnimationFrame(() => { discoveryFrame = null; discover(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  discover();
})();
